import { locationFormDefaultValues } from '../search-windows/configuration';
import { UnitStatusSearchFormType } from './types';

export const unitStatusSearchFormDefaultValues: UnitStatusSearchFormType = {
    agencyProfiles: [],
    agencyType: null,
    assignmentTypes: [],
    callForServices: [],
    dispatchAreas: [],
    eventNumber: '',
    eventOrigins: [],
    locations: [locationFormDefaultValues],
    narrativeKeywords: '',
    personnel: [],
    polygonPoints: [
        { latitude: '', longitude: '' },
        { latitude: '', longitude: '' },
        { latitude: '', longitude: '' },
    ],
    priorities: [],
    stations: [],
    hospitals: [],
    timeRangeOption: {
        label: 'Last 12 Hours',
        value: 'PT12H',
        isCustom: false,
        isDefault: false,
    },
    dateRange: null,
    transitionedBy: [],
    units: [],
    unitStates: [],
    vehicleTags: [],
    fuzzyMatchingEnabled: true,
};

// form is invalid if it's empty and filtering for all time
export const invalidUnitStatusSearchFormValues: UnitStatusSearchFormType = {
    ...unitStatusSearchFormDefaultValues,
    timeRangeOption: {
        label: 'All Time',
        value: 'ALL_TIME',
        isCustom: false,
        isDefault: true,
    },
};
